// @flow

export const VALID = undefined; // undefined represents no error, so valid!
export const SERVER_ERROR_MESSAGE_KEY = 'opened-page:validationError.serverError';
export const SERVER_ERROR_MESSAGE_DEFAULT = 'Server error';
